export const CommonConstants = {
  // ご契約者専用サイト
  MP0000: '000000',
  // 変額保険ポータルトップ
  MP0010: 'MP0010',
  // メール設定
  MP0011: 'MP0011',
  // 解約時精算金
  MP0012: 'MP0012',
  // 運用状況
  MP0020: 'MP0020',
  // 繰入割合変更入力
  MP0030: 'MP0030',
  // 繰入割合変更確認
  MP0031: 'MP0031',
  // 繰入割合変更了解留意事項確認
  MP0032: 'MP0032',
  // 繰入割合変更完了
  MP0033: 'MP0033',
  // 積立金移転入力
  MP0040: 'MP0040',
  // 積立金移転確認
  MP0041: 'MP0041',
  // 積立金移転了解留意事項確認
  MP0042: 'MP0042',
  // 積立金移転完了
  MP0043: 'MP0043',
  // ソーリーページ
  MP9000: 'MP9000',
  // エラー
  MP9010: 'MP9010',
  // 契約内容（PDF）
  '000001': '000001',
  // 完了
  STATUS_COMPLETED: '0',
  // エラー
  STATUS_ERROR: '1',
  // エラーメールアドレス
  ERROR_MAIL_ADDRESS: 'otetsuzuki@daiichilife.com',
};

/**
 * 利用履歴登録の業務画面ID。
 * 呼び出したAPIに対応し、成功・失敗とも同じ値を設定する。
 */
export function resolveUsageHistoryBusinessScreenId(targetOrScreenId: string): string {
  switch (targetOrScreenId) {
    case '000001':
      return CommonConstants['000001'];
    case CommonConstants.MP0011:
      return CommonConstants.MP0011;
    case CommonConstants.MP0012:
      return CommonConstants.MP0012;
    case CommonConstants.MP0020:
      return CommonConstants.MP0020;
    case CommonConstants.MP0030:
    case CommonConstants.MP0031:
    case CommonConstants.MP0032:
    case CommonConstants.MP0033:
      return CommonConstants.MP0030;
    case CommonConstants.MP0040:
    case CommonConstants.MP0041:
    case CommonConstants.MP0042:
    case CommonConstants.MP0043:
      return CommonConstants.MP0040;
    default:
      return CommonConstants.MP0010;
  }
}
